import React, { Fragment, useEffect, useState, useContext, useRef } from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled, {css} from 'styled-components';
import { Context } from '../context';
import { useMousePos } from "./useMousePos";


export function Scrubber({
  width = 120,
  height = 80,
  spriteWidth = 120,
  spriteHeight = 80,
  spriteCount = 100,
  spriteFullWidth = 600,
  spriteFullHeight = 600,
  sprite = 'https://i.ytimg.com/sb/qsxQVTGdMTA/storyboard3_L1/M0.jpg?sqp=-oaymwENSDfyq4qpAwVwAcABBqLzl_8DBgiE4Nv8BQ==&sigh=rs%24AOn4CLBgZ1FP-ATu720AlYI7k-LEGLsWjA',
}) {
  const context = useContext(Context);
  const thumb = useRef();
  const { posX, posY } = useMousePos(thumb.current);
  const [spriteXpos, setSpriteX] = useState(0)
  const [spriteYpos, setSpriteY] = useState(0)

  const [spriteCurrent, setSpriteCurrent] = useState(1)



  let segmentWidth = width / 100;
  let p = width / posX / 10;
  function between(x, min, max) {
    return x >= min && x <= max;
  }
  let segmentArray = Array.apply(null, Array(spriteCount)).map((one, ind) => Math.round((segmentWidth * (ind +1)) * 10 ) / 10 )
  // console.log('segmentArray = ', segmentArray);

  useEffect(() => {
    segmentArray.forEach((one, ind) => {
      if (between(posX, one, segmentArray[ind + 1])) {
        setSpriteCurrent(ind)
        console.log('ind = ', ind);
      }
    })
  }, [posX])


  return (
    <>
      <CSSthumb0
        ref={thumb}
        width={width}
        height={height}
        sprite={sprite}
        spriteX={spriteXpos}
        spriteY={spriteXpos}
      >
        <div>{`X: ${posX}`}</div>
        <div>{`Y: ${posY}`}</div>
      </CSSthumb0>
    </>
  )
}

const CSSthumb0 = styled.div`
  width: ${({width}) => `${width}px`};
  height: ${({height}) => `${height}px`};
  background: #ccc;
  background-position: ${({spriteXpos, spriteYpos}) => `${spriteXpos}px ${spriteYpos}px`};

`